import { Loader } from "../customplugins/loader.js";
import { Toaster } from "../customplugins/toaster.js";
import { ResponsiveCarousel } from "../customplugins/carousel.js";

let selected: number[] = [];

window.addEventListener('load', () => {
    const container = document.querySelector('.product-image-container') as HTMLElement;
    const image = document.getElementById('productImage') as HTMLImageElement;

    if (!container || !image) return;

    container.addEventListener('mousemove', (e: MouseEvent) => {
        const rect = container.getBoundingClientRect();

        const x = e.clientX - rect.left;
        const y = e.clientY - rect.top;

        const xPercent = (x / rect.width) * 100;
        const yPercent = (y / rect.height) * 100;

        image.style.transformOrigin = `${xPercent}% ${yPercent}%`;
        image.style.transform = 'scale(2)';
    });

    container.addEventListener('mouseleave', () => {
        image.style.transform = 'scale(1)';
        image.style.transformOrigin = 'center center';
    });

    const mainImage = document.getElementById("productImage") as HTMLImageElement;

    const thumbnails = document.querySelectorAll(".product-view-tumb-image");

    thumbnails.forEach((thumb) => {
        thumb.addEventListener("click", () => {

            const clickedImage = thumb as HTMLImageElement;
            //const imageSrc = clickedImage.getAttribute("data-image");
            const imageSrc = clickedImage.dataset.image;
            mainImage.src = imageSrc;
        });
    });

    const ProductTumb = document.getElementById("ProductTumb");
    if (ProductTumb) {
        new ResponsiveCarousel("ProductTumb", {
            loop: true,
            margin: 20,
            nav: true,
            autoplay: true,
            autoplayTimeout: 3000,
            responsive: {
                0: { items: 4 },
                600: { items: 4},
                1000: { items: 4 }
            }
        });
    }

});

(window as any).getSelectedAttributes = async function (
    ProductId: number,
    LastSelectedOption: number,
    tenant_id: number
) {

    let selected: number[] = [];

    document.querySelectorAll<HTMLElement>('.attributes').forEach(group => {

        const checked = group.querySelector<HTMLInputElement>('input[type="radio"]:checked');

        if (checked) {
            selected.push(parseInt(checked.value)); // convert to number
        }
    });

     

    var obj = {
        "tenant_id": tenant_id,
        "product_id": ProductId,
        "selected_options": selected,
        "LastSelectedOption": LastSelectedOption

    }
    Loader.show();
    const res = await fetch("/products/getProductDetails", {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify(obj)
    }); 
    Loader.hide();
    const result = await res.text();
    const el = document.getElementById("productDetailsView");
    if (el) {
        el.innerHTML = result;
    }
    const qtyInput = document.getElementById("Qty") as HTMLInputElement | null;

    if (qtyInput) {
        qtyInput.value = "1";
    }
    const container = document.querySelector('.product-image-container') as HTMLElement;
    const image = document.getElementById('productImage') as HTMLImageElement;

    if (!container || !image) return;

    container.addEventListener('mousemove', (e: MouseEvent) => {
        const rect = container.getBoundingClientRect();

        const x = e.clientX - rect.left;
        const y = e.clientY - rect.top;

        const xPercent = (x / rect.width) * 100;
        const yPercent = (y / rect.height) * 100;

        image.style.transformOrigin = `${xPercent}% ${yPercent}%`;
        image.style.transform = 'scale(2)';
    });

    container.addEventListener('mouseleave', () => {
        image.style.transform = 'scale(1)';
        image.style.transformOrigin = 'center center';
    });

    const mainImage = document.getElementById("productImage") as HTMLImageElement;

    const thumbnails = document.querySelectorAll(".product-view-tumb-image");

    thumbnails.forEach((thumb) => {
        thumb.addEventListener("click", () => {

            const clickedImage = thumb as HTMLImageElement;
            //const imageSrc = clickedImage.getAttribute("data-image");
            const imageSrc = clickedImage.dataset.image;
            mainImage.src = imageSrc;
        });
    });

    const ProductTumb = document.getElementById("ProductTumb");
    if (ProductTumb) {
        new ResponsiveCarousel("ProductTumb", {
            loop: true,
            margin: 20,
            nav: true,
            autoplay: true,
            autoplayTimeout: 3000,
            responsive: {
                0: { items: 4 },
                600: { items: 4 },
                1000: { items: 4 }
            }
        });
    }
};